import React, { useState, useEffect, useRef } from 'react';
import { IoMdMenu } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import CustomLink from "./CustomLink";
import { useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import logo from "../../assets/img/logos/logo-no-background.png";

const MobileMenu = ({ links }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const { pathname } = useLocation();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <div className="md:hidden">
            <div className="md:hidden">
                <button className="text-white" onClick={toggleMenu}>
                    <IoMdMenu color='white' size='1.2em' />
                </button>
            </div>
            {isOpen && (
                <div ref={menuRef} className="md:hidden bg-[black] fixed top-0 left-0 w-[85%] h-full bg-opacity-95 flex flex-col justify-center items-center z-50">
                    <div className="absolute top-0 right-0 p-4">
                        <button onClick={toggleMenu}>
                            <IoMdClose color='white' size='1.5em' />
                        </button>
                    </div>
                    <div className="text-white text-2xl mb-8">
                        <img src={logo} alt="logo" className="h-8 md:h-10" />
                    </div>
                    <ul>
                        {links.map((link, index) => (
                            <li key={index} className="mb-4 text-center">
                                <Link
                                    to={link.url}
                                    className={`p-2 rounded-md transition-colors duration-300 ${pathname === link.url ? 'text-[#f4742f] md:bg-[#fffffff9]' : 'text-[white] md:bg-[#f8eded2d] hover:text-[#ffebc7]'}`}
                                    onClick={closeMenu}
                                    >
                                    {link.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default MobileMenu;
